import Bedge from './bedge.svg'
import Fullhorse from './fullhorse.svg'
import Hoursehead from './hoursehead.svg'
import Seahorse from './seahorse.svg'
import Trangle from './trangle.svg'
import Turtle from './turtle.svg'

// SVG ICONS 
const SvgList = [
    {
        id: 123,
        svg: Bedge,
        name: 'badge'
    },
    {   
        id: 124,
        svg: Trangle,
        name: 'Trangle'
    },
    {
        id: 125,
        svg: Fullhorse,
        name: 'horse'
    },
    {
        id: 126,
        svg: Hoursehead,
        name: 'horse head'
    },
    {
        id: 127,
        svg: Seahorse,
        name: 'Sea horse'
    },
    {
        id: 128,
        svg: Turtle,
        name: 'Turtle'
    },
]
export default SvgList

